<template>
  <div
    class="bg-gp-midnight-1/70 z-28 absolute inset-x-0 bottom-0 min-h-screen backdrop-blur-md"
    data-testid="backdrop-blocker"
    :style="{ top: `${y}px` }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useScrollLock, useWindowScroll } from "@vueuse/core";

const scrollLocked = useScrollLock(document.body);

scrollLocked.value = true;

const { y } = useWindowScroll();
</script>
